<div class="map-container" [ngStyle]="{'height.px':height}">
  <div class="header">
    <img class="logo" src="../../assets/logos/logo_trans.png" alt="CotraLogo">
  </div>
  <!--  Shows the map should the job have no errors and not already be completed-->
  <ng-template [ngIf]="!isDelivered && !hasError && lat && lng">
    <agm-map [latitude]="lat"
             [longitude]="lng"
             [zoom]="zoom"
             [usePanning]="usePanning"
             [disableDefaultUI]="disableUi"
             [styles]="mapStyle"
             [mapTypeId]="mapType">
      <agm-marker
        [latitude]="lat"
        [longitude]="lng">
      </agm-marker>
    </agm-map>
  </ng-template>
  <!--  Shows the already delivered box-->
  <ng-template [ngIf]="isDelivered && currentLanguage">
    <div class="bg"></div>
    <div class="custom-container">
      <div class="custom-box">
        <h3>Tracking Service</h3>
        <p>{{ deliveryMessage }}</p>
      </div>
    </div>
  </ng-template>
  <!--  Shows the error box-->
  <ng-template [ngIf]="hasError && currentLanguage">
    <div class="bg"></div>
    <div class="custom-container">
      <div class="custom-box">
        <h3>Error</h3>
        <p>{{ errorMessage}}</p>
      </div>
    </div>
    <!--    Info bar with planned delivery time, only displayed if the order is active-->
  </ng-template>
  <div class="order-info" *ngIf="!isDelivered && !hasError && lat && lng && currentLanguage">
    <div>{{ estimatedDeliveryMessage }}</div>
    <div>{{deliveryDateFrom | date: 'dd.MM.yyy HH:mm'}} - {{deliveryDateTo | date: 'HH:mm'}}</div>
  </div>

</div>
